module.exports = __webpack_public_path__ + "static/img/topBgcbgc.75db6195.png";